import { basePath } from '../next.config'
import { getCookie } from 'cookies-next'
import loggingService from './loggingService'

/**
 * @deprecated Any client-side calls should be converted to server-side calls in ./pages/api/musicapp/_services or
 * ported to ./client/index.ts if necessary
 */
const getCurrentSession = async (): Promise<Session> => {
	if (!getCookie('.auth', {})) return

	let response: Response

	try {
		response = await fetch(`${basePath}/api/musicapp/sessions/current`)

		if (!response.ok) {
			throw new Error(response.status.toString())
		}

		const userData = (await response.json()) as Session

		return {
			user: userData.user,
			expires: new Date(userData.expires),
		}
	} catch (error) {
		loggingService('Error retrieving session', error, {
			errorType: 'Session',
			fetchUrl: response?.url,
			fetchStatus: response?.status,
		})
	}
}

export default getCurrentSession

/**
 * @deprecated Any client-side calls should be converted to server-side calls in ./pages/api/musicapp/_services or
 * ported to ./client/index.ts if necessary
 */
export const flushCurrentSession = async (): Promise<void> => {
	if (!getCookie('.auth', {})) return
	let response: Response
	try {
		response = await fetch(`${basePath}/api/musicapp/sessions/current`, {
			method: 'DELETE',
		})
		if (!response.ok) {
			throw new Error(response.status.toString())
		}
	} catch (error) {
		loggingService('Error flushing user cache', error, {
			errorType: 'Session',
			fetchUrl: response?.url,
			fetchStatus: response?.status,
		})
	}
}
